import { CgShoppingCart } from "react-icons/cg";
import useCartItemCount from "@/hooks/useCartItemCount";
import { withRegionPath } from "@/utils/session";
import styles from "./CartNavLink.module.css";

function formatBadgeCount(count) {
  if (count > 9) return "9+";
  return String(count);
}

export default function CartNavLink({ className, iconSize = 24 }) {
  const count = useCartItemCount();
  const rootClass = [className, styles.root].filter(Boolean).join(" ");

  return (
    <a
      href={withRegionPath("/cart")}
      className={rootClass}
      aria-label={count > 0 ? `Cart, ${count} items` : "Cart"}
    >
      <CgShoppingCart size={iconSize} />
      {count > 0 ? (
        <span className={styles.badge}>{formatBadgeCount(count)}</span>
      ) : null}
    </a>
  );
}
